import { IFilterOption } from "../shared";
import { COMMON_DATE_FILTER_OPTIONS } from "../../constants";

export enum EOperationStatusFilterId {
  ALL_TASKS = "all-tasks",
  PENDING_REVIEW = "pending-review",
  DONE = "done",
}

export const COMMON_OPERATION_STATUS_FILTER_OPTIONS: IFilterOption[] = [
  ...COMMON_DATE_FILTER_OPTIONS,
  {
    id: EOperationStatusFilterId.ALL_TASKS,
    label: "All Tasks",
    default: true,
  },
];

// Service category filter options
export const SERVICE_CATEGORY_FILTER_OPTIONS: IFilterOption[] = [
  {
    id: "all-sessions",
    label: "All Sessions",
    default: true,
  },
  {
    id: "walking",
    label: "Walking",
  },
  {
    id: "grooming",
    label: "Grooming",
  },
];

// Combined filter options: date filters + status filters + service category filters
export const OPERATION_SESSIONS_FILTER_OPTIONS: IFilterOption[] = [
  ...COMMON_OPERATION_STATUS_FILTER_OPTIONS,
  ...SERVICE_CATEGORY_FILTER_OPTIONS,
];

